import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=30c81beb&scoped=true&"
import script from "./VideoCarousel.vue?vue&type=script&lang=js&"
export * from "./VideoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VideoCarousel.vue?vue&type=style&index=0&id=30c81beb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c81beb",
  null
  
)

export default component.exports